import type { Shape } from "@gettactic/map-builder/src/types";

export type ResizeHandle = "nw" | "n" | "ne" | "e" | "se" | "s" | "sw" | "w";
export type HandleKind = ResizeHandle | "rotate";

export const RESIZE_HANDLES: ResizeHandle[] = [
  "nw",
  "n",
  "ne",
  "e",
  "se",
  "s",
  "sw",
  "w"
];

export const HANDLE_CURSORS: Record<HandleKind, string> = {
  nw: "nwse-resize",
  se: "nwse-resize",
  ne: "nesw-resize",
  sw: "nesw-resize",
  n: "ns-resize",
  s: "ns-resize",
  e: "ew-resize",
  w: "ew-resize",
  rotate: "grab"
};

/** Shapes whose size is their width/height box. Spots have a fixed layout,
 *  walls live on their endpoints, groups size from their children. */
export const isResizable = (shape: Shape): boolean =>
  !shape.locked &&
  (shape.type === "rectangle" ||
    shape.type === "circle" ||
    shape.type === "zone" ||
    shape.type === "image" ||
    shape.type === "svg" ||
    shape.type === "icon" ||
    shape.type === "furniture" ||
    shape.type === "text");

export const isRotatable = (shape: Shape): boolean =>
  !shape.locked &&
  shape.type !== "wall" &&
  shape.type !== "wall-path" &&
  shape.type !== "group" &&
  shape.type !== "zone";
